import React, { useState, useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import './login.css'
import logo from '../../Assets/images/logo.png'
import bookIcon from '../../Assets/images/book.png'
import userIcon from '../../Assets/images/group.png'
import ebookIcon from '../../Assets/images/e-book.png'
import qPaperIcon from '../../Assets/images/question.png'
import playstoreIcon from '../../Assets/images/playstoreIcon.png'
import appstoreIcon from '../../Assets/images/appstoreIcon.png'

import { MyLoginModal1 } from './LoginModal'
import { ForgotModal1 } from './ForgotModal'
import { MyRegModal1 } from './RegistrationModal'

//redux
import { useDispatch } from 'react-redux'
import { userLogin } from '../../ReduxStore/Action/LoginAction'

// APIURL
import { userLoginAPI, userLoginNewAPI } from '../../Services/LoginAPIURL'
import { forgotPasswordAPI } from '../../Services/PasswordAPIURL'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { indexRoutesAPI } from '../../Services/HomeAPIURL'
import { getInstituteAPI } from '../../Services/InstituteMasterAPIURL'


//Loader
import Loader from '../CommonComponents/Loader/Loader'

const Login = ({ setIsUser, setShowCancelPage, setShowPrivacyPage }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loaderOption, setLoaderOption] = useState(false)

  const [showLoginModal, setShowLoginModal] = useState(false)
  const [showRegModal, setShowRegModal] = useState(false)
  const [showForgotModal, setShowForgotModal] = useState(false)

  const [countData, setCountData] = useState([])

  //Institute Master Data
  const [instData, setInstData] = useState([])

  //Form Variables
  const [loginId, setLoginId] = useState('')
  const [password, setPassword] = useState('')
  const [instituteId, setInstituteId] = useState('') //For single institute default value is 1
  const [email, setEmail] = useState('')

  const getData = async () => {
    await axios.get(indexRoutesAPI).then((res) => {
      if (res.data === 'ERROR') {
        console.log('Error Occured')
      } else {
        setCountData(res.data)
      }
    })

    await axios.get(getInstituteAPI).then((res) => {
      if (res.data === 'ERROR') {
        console.log('Error Occured')
      } else {
        setInstData(res.data)
      }
    })
  }
  useEffect(() => {
    getData()
  }, [])

  const LoginFun = async (e) => {
    e.preventDefault()
    setLoaderOption(true)

    if (loginId.trim() === '' || password.trim() === '') {
      setLoaderOption(false)
      toast.error('Fields must not be empty')
      return
    }

    const loginObject = {
      instituteId: instituteId,
      loginId: loginId,
      password: password,
    }

    try {
      const res = await axios.post(userLoginNewAPI, loginObject)

      if (res.data.status === 'success') {
        const logObject = {
          member_name: res.data.data.member_name,
          member_type: res.data.data.member_type,
          institute_id: res.data.data.institute_id,
          id: res.data.data.id,
          token: res.data.token,
        }

        // Save User
        sessionStorage.setItem('digital-library', JSON.stringify(logObject))

        // Save JWT Token separately
        sessionStorage.setItem('token', res.data.token)

        dispatch(userLogin(logObject))

        toast.success(res.data.message)

        setTimeout(() => {
          setIsUser(true)
        }, 800)
      } else {
        toast.error(res.data.message || 'Invalid Username or Password')
      }
    } catch (err) {
      console.error(err)

      if (err.response?.data?.message) {
        toast.error(err.response.data.message)
      } else {
        toast.error('Network error. Try after sometime.')
      }
    } finally {
      setLoaderOption(false)
    }
  }

  const ForgotFun = async (e) => {
    setLoaderOption(true)
    e.preventDefault()
    // alert(email)
    const sendObj = {
      email: email,
    }

    await axios
      .post(forgotPasswordAPI, sendObj)
      .then((res) => {
        if (res.data === 'NOTMATCH') {
          setLoaderOption(false)
          toast.warn('Wrong Email Id.')
        } else if (res.data === 'SENT') {
          clearFun()
          setShowForgotModal(false)
          setLoaderOption(false)
          toast.success('Your password has been sent to your email id.')
        } else if (res.data === 'ERROR') {
          setLoaderOption(false)
          toast.error('Error occured, Something went wrong.')
        } else {
          setLoaderOption(false)
          console.log('Error : ' + JSON.stringify(res.data))
        }
      })
      .catch((err) => {
        setLoaderOption(false)
        console.log('Error :' + err)
      })
  }

  const clearFun = () => {
    setLoginId('')
    setPassword('')
    setEmail('')
  }

  return (
    <>
      {loaderOption ? <Loader /> : null}
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      <div className="container mt-4">
        <div className="col-12 text-center">
          <img src={logo} style={{ width: 120 }} alt="Logo" />
        </div>
        <div className="col-12 text-center mt-4">
          <h5 className="headTitle">Latthe Education Society's</h5>
          <h1 className="headTitle" style={{ fontFamily: 'Libre Baskerville' }}>
            Shri. Jaykumar Babgonda Patil Digital Library
          </h1>
        </div>

        <div className="card-container">
          <div className="cards text-center">
            <img src={bookIcon} alt="Book Icon" />
            <br />
            <strong>BOOKS</strong>
            <h5>{countData.length > 0 ? countData[0].books : '000'}</h5>
          </div>

          <div className="cards text-center">
            <img src={userIcon} alt="User Icon" /> <br />
            <strong>USERS</strong>
            <h5>{countData.length > 0 ? countData[0].user : '000'}</h5>
          </div>

          <div className="cards text-center">
            <img src={ebookIcon} alt="E-Book Icon" />
            <br />
            <strong>E-BOOKS</strong>
            <h5>{countData.length > 0 ? countData[0].ebooks : '000'}</h5>
          </div>

          <div className="cards text-center">
            <img src={qPaperIcon} alt="Que-Paper Icon" />
            <br />
            <strong>QUESTION-PAPER</strong>
            <br />
            <h5>{countData.length > 0 ? countData[0].qpaper : '000'}</h5>
          </div>
        </div>

        <div className="card-container mt-4">
          <span className="loginBtn" onClick={() => setShowLoginModal(true)}>
            LOGIN
          </span>
          <span className="regBtn" onClick={() => setShowRegModal(true)}>
            REGISTER
          </span>

          {/* <span className="regBtn" onClick={() => navigate("/cancel-membership")}>
            CANCEL MEMBERSHIP
          </span> */}

          <span className="regBtn" onClick={() => setShowCancelPage(true)}>
            CANCEL MEMBERSHIP
          </span>
          {/* <span className="regBtn" onClick={() => setShowPrivacyPage(true)}>
            PRIVACY POLICY
          </span> */}

          {/* <span className="regBtn" onClick={() => navigate("/privacy-policy")}>
            PRIVACY POLICY
          </span> */}
          <a href="\privacy-policy.html" className="regBtn">
            PRIVACY POLICY
          </a>
        </div>
      </div>

      <div className="footer">
        <div className="fc1">
          © LES Digital Library 2022 | Managed by:{' '}
          <a href="https://technoaarv.com/" target="_blank">
            TechnoAarv Solution
          </a>
        </div>

        <div className="fc3">
          <a
            // href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            href='https://apps.apple.com/in/app/les-digital-library/id6792469948'
            target="_blank"
          >
            <img src={appstoreIcon} alt="App store Icon" />
          </a>
        </div>

        <div className="fc2">
          <a
            // href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            href='https://play.google.com/store/apps/details?id=com.les.digitallibrary&pcampaignid=web_share'
            target="_blank"
          >
            <img src={playstoreIcon} alt="Playstore Icon" />
          </a>
        </div>

        
      </div>

      <MyLoginModal1
        showLoginModal={showLoginModal}
        setShowLoginModal={setShowLoginModal}
        loginId={loginId}
        setLoginId={setLoginId}
        password={password}
        setPassword={setPassword}
        LoginFun={LoginFun}
        clearFun={clearFun}
        setShowForgotModal={setShowForgotModal}
        setShowRegModal={setShowRegModal}
        instData={instData}
        setInstituteId={setInstituteId}
        instituteId={instituteId}
      />

      <MyRegModal1
        showRegModal={showRegModal}
        setShowRegModal={setShowRegModal}
        setShowLoginModal={setShowLoginModal}
        instData={instData}
      />

      <ForgotModal1
        showForgotModal={showForgotModal}
        setShowForgotModal={setShowForgotModal}
        email={email}
        setEmail={setEmail}
        clearFun={clearFun}
        ForgotFun={ForgotFun}
      />

      <ToastContainer theme="dark" position="top-right" />
    </>
  )
}

export default Login
